import axiosInstance from '../../components/api/axiosInstance';

export const domainService = {
  getDomains: (params = {}) =>
    axiosInstance.get('/api/business/domains', { params }).then((r) => r.data),

  addDomain: (domainName) =>
    axiosInstance.post('/api/business/domains/add', { domainName }).then((r) => r.data),

  verifyDomain: (domainId) =>
    axiosInstance.post('/api/business/domains/verify', { domainId }).then((r) => r.data),

  checkSSL: (domainId) =>
    axiosInstance.post('/api/business/domains/ssl-check', { domainId }).then((r) => r.data),

  healthCheck: (domainId) =>
    axiosInstance.post('/api/business/domains/health-check', { domainId }).then((r) => r.data),

  deleteDomain: (domainId) =>
    axiosInstance.delete(`/api/business/domains/${domainId}`).then((r) => r.data),
};
